import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import SubscriptionFactory from "../../Entity/Factories/SubscriptionFactory";
import { SubscriptionInterface } from "../../Entity/Entities/Subscription/SubscriptionInterface";

export default function* subscriptionCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_SUBSCRIPTION_CREATE_REQUEST
    });

    const res = yield call(Http.post, `subscription`, action.payload?.subscription);
    const subscription: SubscriptionInterface = SubscriptionFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_SUBSCRIPTION_CREATE_SUCCESS,
      payload: {
        subscription: subscription
      }
    });

  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_SUBSCRIPTION_CREATE_FAILURE,
      payload: {
        err: err
      }
    });

  }
}

export function* watchSubscriptionCreate() {
  yield takeEvery(Constants.GLOBAL_SUBSCRIPTION_CREATE_START, subscriptionCreate);
}
